import { getStore } from '../../../../../../../../store/client';
import { getScoring, scoringToFormData } from '../../../../../../../../helpers/form.new/tasks/get.scoring';
import { extendFormData } from '../../../../../../../../store/reducers/formStore';
import { getAddress } from '../../../../../../../../helpers/form.new/tasks/get.address';
import analytics from '../../../../../../../../helpers/analytics';

export const onComplete = async () => {
    const { dispatch } = getStore();
    const { formData } = getStore().getState().formStore;
    const { loggedInSilent, loggedIn } = getStore().getState().user;
    const isRequestingScoring = loggedIn && !loggedInSilent;
    await Promise.all([
        isRequestingScoring
            ? getScoring(formData).then((scoreData) => {
                  const { score, scoreType } = scoreData;
                  const model = scoreType === 'gen7' ? 'score_point_ekvifax' : 'score_point_gen7_cl';

                  analytics.emit({
                      event: analytics.events.mainEvent,
                      eventCategory: analytics.categories.CreditCard,
                      eventAction: 'Показ скорбалла',
                      eventLabel: [`${model} - ${score ? Math.floor(score as number) : 'Не найден'}`].join('|'),
                  });
                  dispatch(extendFormData(scoringToFormData(scoreData)));
              })
            : Promise.resolve(),
        getAddress(formData).then((addresses) => {
            dispatch(extendFormData(addresses));
        }),
    ]);
};
